<template>
  <div>
    <div
      class="text-md font-medium text-white py-2 px-5 rounded mt-4 cursor-pointer flex justify-between"
      v-on:click="show_div = !show_div"
      :class="
        show_div
          ? 'bg-theme-1 text-white'
          : 'bg-white border border-theme-1 text-theme-1 hover:bg-theme-1 hover:text-white'
      "
    >
      <span class="my-auto">{{ show_div ? 'Ocultar' : 'Ver' }} listado</span>
      <span class="font-bold text-lg">{{ show_div ? '-' : '+' }}</span>
    </div>

    <CreateTaskModal
      v-if="createTaskModalOption"
      @closeModal="setCreateTaskModal(false)"
      @secondPlanningCreated="secondPlanningCreated()"
      :task_current="task_current"
    />

    <div
      class="overflow-auto intro-y"
      v-if="show_div && !createTaskModalOption"
    >
      <table class="table table-report -mt-2">
        <thead>
          <tr>
            <th class="whitespace-no-wrap">TAREA</th>
            <th class="text-center whitespace-no-wrap">HORAS</th>
            <th class="text-center whitespace-no-wrap">
              <div
                class="flex justify-center gap-2 cursor-pointer hover:text-theme-1"
                v-if="filter_date"
                @click="filter_date = !filter_date"
              >
                FECHA
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-4 h-4"
                >
                  <path
                    fill-rule="evenodd"
                    d="M3.792 2.938A49.069 49.069 0 0 1 12 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 0 1 1.541 1.836v1.044a3 3 0 0 1-.879 2.121l-6.182 6.182a1.5 1.5 0 0 0-.439 1.061v2.927a3 3 0 0 1-1.658 2.684l-1.757.878A.75.75 0 0 1 9.75 21v-5.818a1.5 1.5 0 0 0-.44-1.06L3.13 7.938a3 3 0 0 1-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="flex justify-center gap-2" v-else>
                <input
                  type="date"
                  v-model="filter.date"
                  class="input w-full border mt-2 flex-1 text-center"
                  required
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-4 h-4 my-auto cursor-pointer hover:text-theme-1"
                  @click="closeFilterDate()"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </th>
            <th class="text-center whitespace-no-wrap w-40">
              <select
                class="input w-full border mt-2 flex-1 text-center"
                v-model="filter.account_id"
                required
              >
                <option value="-" selected>CUENTAS</option>
                <option
                  v-for="account in accounts"
                  :value="account.id"
                  :key="`account-${account.id}`"
                >
                  {{ account.name }}
                </option>
              </select>
            </th>
            <th class="text-center whitespace-no-wrap w-40">
              <select
                class="input w-full border mt-2 flex-1 text-center"
                v-model="filter.user_id"
              >
                <option value="-" selected>ASIGNADO</option>
                <option
                  v-for="user in filteredUsers"
                  :value="user.id"
                  :key="`user-${user.id}`"
                >
                  {{ user.name }}
                </option>
              </select>
            </th>
            <th class="text-center whitespace-no-wrap">ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="intro-x"
            v-for="(item, index) in filteredItems"
            v-bind:key="'list' + index"
          >
            <td>
              <input
                v-if="editIndex === index"
                type="text"
                v-model="current_planning.task"
                required
                :class="`input w-full border mt-2 flex-1`"
              />
              <div
                v-else
                class="text-gray-600 text-xs whitespace-no-wrap flex gap-1"
                :class="item.task_created ? 'text-theme-1' : ''"
              >
                <app-icon v-bind:name="'check-circle'" v-bind:classname="'w-5 h-5 text-theme-9'" v-if="item.planning_id"></app-icon>
                <app-icon v-bind:name="'check-circle'" v-bind:classname="'w-5 h-5 text-theme-1'" v-if="item.task_created"></app-icon>
                {{ item.task | limit }}
              </div>
            </td>
            <td class="w-32">
              <input
                v-if="editIndex === index && [2, 3].includes(user.team_id)"
                type="number"
                v-model="current_planning.hours"
                required
                :class="`input w-full border mt-2 flex-1`"
              />
              <div
                v-else
                class="text-gray-600 text-xs whitespace-no-wrap text-center"
              >
                {{ item.hours }}
              </div>
            </td>
            <td class="w-24">
              <input
                v-if="editIndex === index && [2, 3].includes(user.team_id)"
                type="date"
                v-model="current_planning.date"
                required
                :class="`input w-full border mt-2 flex-1`"
              />
              <div
                v-else
                class="text-gray-600 text-xs whitespace-no-wrap text-center"
              >
                {{ item.date }}
              </div>
            </td>
            <td class="w-40">
              <select
                v-if="editIndex === index && [2, 3].includes(user.team_id)"
                class="input w-full border mt-2 flex-1"
                v-model="current_planning.account_id"
              >
                <option value="">Seleccione...</option>
                <option
                  v-for="account in accounts"
                  :value="account.id"
                  :key="`account-${account.id}`"
                >
                  {{ account.name }}
                </option>
              </select>
              <div
                v-else
                class="text-gray-600 text-xs whitespace-no-wrap text-center"
              >
                {{ item.account.name }}
              </div>
            </td>
            <td class="w-20">
              <select
                v-if="editIndex === index && [2, 3].includes(user.team_id)"
                class="input w-full border mt-2 flex-1"
                v-model="current_planning.user_id"
              >
                <option value="">Seleccione...</option>
                <option
                  v-for="user in filteredUsers"
                  :value="user.id"
                  :key="`user-${user.id}`"
                >
                  {{ user.name }}
                </option>
              </select>
              <div class="w-24 h-24 lg:w-12 lg:h-12 image-fit mx-auto" v-else>
                <img
                  :title="item.created_user.name"
                  class="rounded-full mx-auto -ml-6"
                  :src="item.created_user.avatar"
                  v-if="item.created_user"
                />
                <img
                  :title="item.user.name"
                  class="rounded-full mx-auto"
                  :src="item.user.avatar"
                  v-if="item.user"
                />
              </div>
            </td>
            <td class="table-report__action text-center">
              <button
                v-if="editIndex === index"
                @click="updateItem()"
                class="bg-green-400 text-white rounded py-1 px-2 text-xs"
              >
                Guardar
              </button>
              <button
                v-else
                @click="editItem(index, item)"
                type="button"
                class="bg-theme-1 text-white rounded py-1 px-2 text-xs"
              >
                Editar
              </button>
              <button
                v-if="[2, 3].includes(user.team_id)"
                @click="removeItem(item)"
                type="button"
                class="bg-red-600 text-white rounded py-1 px-2 text-xs"
              >
                Eliminar
              </button>
              <button v-if="!item.task_created"
                class="bg-theme-3 text-white rounded py-1 px-2 text-xs"
                @click="openCreateTask(item)"
              >
                Crear Tarea
              </button>
              <button v-if="item.number_versions == 0"
                class="bg-theme-11 text-white rounded py-1 px-2 text-xs"
                @click="newVersion(item)"
              >
                Nueva Versión
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreateTaskModal from './CreateTaskModal.vue'
import Icon from '@/components/admin/partials/Icon'

export default {
  name: 'ListPlanning',
  props: ['accounts', 'users', 'items', 'user', 'team_session'],
  data() {
    return {
      show_div: false,
      editIndex: null,
      current_planning: {
        account_id: '',
        user_id: '',
        task: '',
        hours: '',
        date: '',
        entity: 'planning',
        id: '',
      },
      filter_date: true,
      filter: {
        account_id: '-',
        user_id: '-',
      },
      createTaskModalOption: false,
      task_current: null,
    }
  },
  computed: {
    filteredUsers() {
      return this.users.filter((item) => {
        return this.team_session ? item.team_id == this.team_session : true
      })
    },
    filteredItems() {
      return this.items.filter((item) => {
        let account =
          this.filter.account_id === '-'
            ? true
            : item.account_id == this.filter.account_id
        let user =
          this.filter.user_id === '-'
            ? true
            : item.user_id == this.filter.user_id
        let date = this.filter.date ? item.date == this.filter.date : true

        return account && user && date
      })
    },
  },
  methods: {
    editItem(index, item) {
      this.editIndex = index
      this.current_planning.task = item.task
      this.current_planning.hours = item.hours
      this.current_planning.date = item.date
      this.current_planning.id = item.id
      this.current_planning.account_id = item.account_id
      this.current_planning.user_id = item.user_id
    },
    updateItem() {
      //console.log(this.current_planning)
      this.put(this.current_planning)
        .then((item) => {
          this.$emit('planningCreated')
          this.show_div = true
          this.editIndex = null
        })
        .catch((message) => {})
        .finally(() => {})
    },
    removeItem(item) {
      this.form = {
        id: item.id,
        entity: 'planning',
      }
      //console.log(this.form)
      this.remove(this.form)
        .then((item) => {
          this.$emit('planningCreated')
        })
        .catch((message) => {})
        .finally(() => {})
    },
    newVersion(item) {
      this.$emit('setPlanningId', item.id)
    },
    closeFilterDate() {
      this.filter.date = ''
      this.filter_date = true
    },
    openCreateTask(item) {
      //console.log(item)
      this.task_current = item
      this.setCreateTaskModal(true)
    },
    setCreateTaskModal(boolean) {
      this.createTaskModalOption = boolean
    },
    secondPlanningCreated() {
      console.log('planningCreated')
      this.$emit('planningCreated')
    },
    ...mapActions(['put', 'remove']),
  },
  components: {
    CreateTaskModal,
    appIcon: Icon,
  },
}
</script>



// WEBPACK FOOTER //
// ListPlanning.vue?7a79d69e